module.exports = __webpack_public_path__ + "static/media/shuffle.b02fb178.png";